import React, { createContext, useState } from 'react';

// Create a context with initial value
export const MyContext = createContext<any>(null);

// Create a provider component to wrap around components that need access to the context
export const MyContextProvider = ({ children }:any) => {
  const [state, setState] = useState();

  // You can also define functions or any other data that you want to share through the context

  return (
    <MyContext.Provider value={{ state, setState }}>
      {children}
    </MyContext.Provider>
  );
};